import { DownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Подвал бесконечной таблицы.
 *
 * Кнопка живёт внутри карточки под таблицей, отделённая линией, а не висит
 * отдельным блоком под ней: иначе она читается как действие над страницей
 * целиком, а не как продолжение списка.
 *
 * Ничего не рисует, когда страниц больше нет, — чтобы вызывающий код не
 * повторял `hasNextPage &&` на каждой из шести таблиц.
 */
export function LoadMore({
  hasMore,
  loading,
  onClick,
}: {
  hasMore: boolean;
  loading: boolean;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  if (!hasMore) return null;

  return (
    <div style={{ padding: 12, borderTop: "1px solid var(--ant-color-split)" }}>
      <Button block icon={<DownOutlined aria-hidden />} loading={loading} onClick={onClick}>
        {t("common.loadMore")}
      </Button>
    </div>
  );
}
